var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Redirect, Route } from 'react-router-dom';
import { LOCAL_STORAGE_KEY } from 'constants/storage';
import { getLocalStorageItem } from 'utils/localStorage';
var PrivateRoute = function (_a) {
    var redirectPath = _a.redirectPath, children = _a.children, props = __rest(_a, ["redirectPath", "children"]);
    var token = getLocalStorageItem({
        key: LOCAL_STORAGE_KEY.ACCESS_TOKEN,
        defaultValue: '',
    });
    return _jsx(Route, __assign({}, props, { children: token ? children : _jsx(Redirect, { to: redirectPath }, void 0) }), void 0);
};
export default PrivateRoute;
